import {
  ServiceManagerOptions,
  StorageManagerOptions,
  TokenManagerOptions,
} from '@okta/okta-auth-js';
import { createContext } from 'react';

export type AuthConfig = {
  clientId: string;
  disableHttpsCheck: boolean;
  ignoreLifetime: boolean;
  interactionCodeFlow: boolean;
  issuer: string;
  maxClockSkew: number;
  pkce: boolean;
  redirectUri: string;
  scopes: string[];
  services: ServiceManagerOptions;
  storageManager: StorageManagerOptions;
  tokenManager: TokenManagerOptions;
};

export const authConfigContext = createContext<AuthConfig | undefined>(
  undefined
);
